<h1 class="text-center">{{ 'bekocheck.eingabe.start.headline' | translate: welcomePlaceholder }}</h1>
<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-offset-2 medium-3">
    <app-advisor-image path="/bkc/bkc-einstieg.svg"></app-advisor-image>
    <app-advisor-image path="/bkc/logo-dmb.svg"></app-advisor-image>
  </div>
  <div class="cell small-12 medium-5">
    <p [innerHTML]="'bekocheck.eingabe.start.teaser' | translate"></p>
    <div class="callout lighter-gray show-for-large" [innerHTML]="'bekocheck.eingabe.start.callout2' | translate"></div>
  </div>
  <div class="cell small-12 medium-offset-1 medium-10">
    <div class="callout lighter-gray hide-for-large" [innerHTML]="'bekocheck.eingabe.start.callout2' | translate"></div>
    <div class="button-wrapper background">
      <div [innerHTML]="'bekocheck.eingabe.start.callout1' | translate"></div>
      <button [routerLink]="nextLink" class="button primary inline-arrow-right">{{'bekocheck.eingabe.start.next' | translate}}</button>
    </div>
  </div>
</div>
